import swal from "sweetalert";
import http_service from "../classes/http";
import { bus } from '../other/bus'

let http = new http_service(bus);

export default {
  namespaced: true,
  state: {
    classes: [],
    homework: [],

  },
  mutations: {
    setStudentClasses(state, items) {
      state.classes = items;
    },
    setStudentHomework(state, items) {
      state.homework = items
    },
    completeHomework(state, params) {
      let hw = state.homework[params.date].find(item => item.id === params.id)
      let total = +hw.total
      total++
      hw.total = total

      if (total === hw.homework.template.qnt) {
        hw.is_done = 1
        hw.status = 'Выполнено'
      }      
    }
  },
  actions: {
    async getStudentsClasses(ctx, id) {
      let classes = await http.post('onGetStudentClasses', { id }).then(res => res.data)
      ctx.commit('setStudentClasses', classes);
    },
    getHomework(ctx, id) {
      http.post('onGetStudentHomeworks', { id }).then(res => {
        let keys = Object.keys(res.data).sort((a, b) => moment(a, 'DD.MM.YYYY') - moment(b, 'DD.MM.YYYY'))

        let items = {}
        keys.forEach(key => {
          items[key] = res.data[key]
        })

        console.log(items)
        ctx.commit('setStudentHomework', items);
      });     
    }
  },
  getters: {
    classes(state) {
      return state.classes
    },
    homework(state) {
      return state.homework
    }
  }
}